<template>
  <v-form
    ref="demoQualifierForm"
    lazy-validation
    class="d-flex pa-0"
  >
    <v-col
      class="d-flex justify-space-between align-center pa-0 pr-3"
      md="8"
    >
      <v-card flat>
        <v-card-subtitle class="pa-0 justify-center d-flex align-end"> Age Range </v-card-subtitle>
        <v-card-text class="d-flex justify-space-around pa-0">
          <v-row class="d-flex justify-space-between">
            <v-col md="6">
              <v-text-field
                name="ageDemoQualifier"
                id="ageDemoQualifier"
                type="number"
                outlined
                dense
                v-model="ageFrom"
                hide-details="true"
                @change="setAgeFrom"
              ></v-text-field>
            </v-col>
            <v-col md="6">
              <v-text-field
                name="ageDemoQualifier"
                id="ageDemoQualifier"
                type="number"
                outlined
                dense
                v-model="ageTo"
                hide-details="true"
                @blur="setAgeTo"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="d-flex pa-0 pt-4">
          <v-row class="d-flex justify-center">
            <v-alert
              dense
              text
              type="error"
              :value="!valid"
              style="margin-bottom: 0"
            >
              {{ errorMessage }}
            </v-alert>
            <v-alert
              dense
              text
              type="info"
              :value="info && valid"
              style="margin-bottom: 0"
            >
              {{ infoMessage }}
              <v-progress-linear :value="infoMessageCounter"></v-progress-linear>
            </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      md="4"
      class="pr-0 d-flex align-center"
    >
      <v-select
        :items="genderOptions"
        v-model="gender"
        label="Gender"
        clearable
        @change="setDemoQualifier"
      ></v-select>
    </v-col>
  </v-form>
</template>

<script>
  const MIN_AGE = 18
  const MAX_AGE = 99
  export default {
    components: {},
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        genderOptions: ['M', 'F'],
        gender: null,
        ageFrom: MIN_AGE,
        ageTo: MAX_AGE,
        errorMessage: null,
        valid: true,
        info: false,
        infoMessage: null,
        infoMessageCounter: 100,
        infoMessageInterval: null,
      }
    },
    mounted() {
      this.setDemoQualifier()
    },
    computed: {
      validAgeRange() {
        if (this.ageFrom && this.ageTo) {
          if (this.ageFrom > this.ageTo) {
            this.errorMessage = 'Invalid Age range'
            this.valid = false
          } else {
            this.valid = true
          }
        } else {
          this.errorMessage = 'Age is mandatory'
          this.valid = false
        }
        return this.valid
      },
    },
    methods: {
      setDemoQualifier() {
        if (this.validAgeRange) {
          let demoQualifier = `${this.gender ? this.gender : 'A'}${this.ageFrom}${
            Number(this.ageTo) === 99 ? '+' : this.ageTo
          }`
          this.$emit('demoQualifier', demoQualifier)
        } else {
          this.$emit('demoQualifier', null)
        }
      },
      setAgeFrom() {
        if (Number(this.ageFrom) < Number(MIN_AGE)) {
          this.ageFrom = MIN_AGE
          this.showInfoMessage(`Value reset to ${MIN_AGE}`)
          this.info = true
        } else if (Number(this.ageFrom) > Number(MAX_AGE)) {
          this.ageFrom = MAX_AGE
          this.showInfoMessage(`Value reset to ${MAX_AGE}`)
        } else {
          this.resetInfoMessage()
        }
        this.setDemoQualifier()
      },
      setAgeTo() {
        if (Number(this.ageTo) > Number(MAX_AGE)) {
          this.ageTo = MAX_AGE
          this.showInfoMessage(`Value reset to ${MAX_AGE}`)
        } else if (Number(this.ageTo) < Number(MIN_AGE)) {
          this.ageTo = MIN_AGE
          this.showInfoMessage(`Value reset to ${MIN_AGE}`)
        } else {
          this.resetInfoMessage()
        }
        this.setDemoQualifier()
      },
      resetInfoMessage() {
        this.infoMessage = null
        this.info = false
      },
      showInfoMessage(msg) {
        this.info = true
        this.infoMessage = `${msg}`
        this.infoMessageCounter = 100
        this.infoMessageInterval = setInterval(() => {
          this.infoMessageCountdown()
        }, 50)
      },
      infoMessageCountdown() {
        if (this.infoMessageCounter === 0) {
          this.infoMessage = null
          this.info = false
          clearInterval(this.infoMessageInterval)
        } else {
          this.infoMessageCounter -= 2
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// DemoQualifier.vue?e8921bd4